export const PYTH_NETWORK_HERMES_BASE_URI_PRODUCTION = 'https://hermes.pyth.network'
export const PYTH_NETWORK_HERMES_BASE_URI_DEVELOPMENT = 'https://hermes-beta.pyth.network'

// TODO: Add achievo oracles here
